import * as CONST from 'Reducers/Filter/const'

/**
 * Send action to clear filters
 */
export function clearAllFilters() {
  return {
    type: CONST.CLEAR_ALL_FILTERS,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Filter/actions.js